module.exports = __webpack_public_path__ + "img/Slide12.dd6fe995.png";